export default __webpack_public_path__ + "static/media/Custom2.a0714305.png";